export default "__VITE_ASSET__DRnshSXg__"